import React from "react";
import { Columns, LegacyCard, Stack, Text } from "@shopify/polaris";
import { Field } from "react-final-form";
import RedirectSelectField from "../RedirectSelectField.js";
import SelectedTagsField from "../../../../../common/SelectedTagsField/SelectedTagsField.js";
import TagsCheckbox from "../TagsCheckbox/TagsCheckbox.js";
import {
  REDIRECT_CUSTOM_URL,
  REDIRECT_SPECIFIC_BLOG_POST,
  REDIRECT_SPECIFIC_PRODUCT_PAGE,
  REDIRECT_SPECIFIC_SHOPIFY_PAGE
} from "../../../../../../../constants/redirectTypes.js";
import CustomRedirectField from "../CustomRedirectField.js";
import SpecificPageField from "../SpecificPageField.js";
import SpecificBlogField from "../SpecificBlogField.js";
import SpecificProductField from "../SpecificProductField.js";


const HideProductsCard = ({ values }) => {
  return (
    <LegacyCard>
      <LegacyCard.Section>
        <Columns columns={{ xs: "1fr 1fr" }}>
          <Stack vertical>
            <Field name="hideProductRedirect" component={RedirectSelectField} />
            {values.hideProductRedirect === REDIRECT_CUSTOM_URL &&
              <Field name="hideProductCustomRedirectURL" component={CustomRedirectField} />}
            {values.hideProductRedirect === REDIRECT_SPECIFIC_SHOPIFY_PAGE &&
              <Field name="hideProductSpecificShopifyPage" component={SpecificPageField} />}
            {values.hideProductRedirect === REDIRECT_SPECIFIC_BLOG_POST &&
              <Field name="hideProductSpecificShopifyBlog" component={SpecificBlogField} />}
            {values.hideProductRedirect === REDIRECT_SPECIFIC_PRODUCT_PAGE &&
              <Field name="hideProductSpecificProductPage" component={SpecificProductField} />}
            <Field name="hideProductIsActiveTags" component={TagsCheckbox} isTooltip
              label="Tag products that were hidden by Stockhide" />
            <div style={{ paddingLeft: "1.75rem" }}>
              <Field name={"hideProductSelectedTags"} component={SelectedTagsField} labelHidden={true}
                disabled={!values.hideProductIsActiveTags} />
            </div>
          </Stack>
        </Columns>
      </LegacyCard.Section>
    </LegacyCard>
  );
};

export default HideProductsCard;